import * as S from './CreditBox.styles'
import { ReactComponent as CreditIcon } from '../../icons/assets/credit.svg'
import { useAccount } from '../Account/AccountProvider'
import { formatPrice } from '../../utils/utils'
import { Flex } from 'mixtiles-web-common'
import { useTranslation } from 'react-i18next'
import { usePricing } from 'components/Pricing/PricingProvider'

export default function CreditBox() {
  const { isAuthenticated, isLoading, account } = useAccount()
  const { pricingData } = usePricing()
  const { currency } = pricingData
  const { t } = useTranslation()
  const creditExist =
    account?.availableCredits && account?.availableCredits !== 0
  if (!creditExist || !isAuthenticated || isLoading) {
    return ''
  }
  const formattedCredits = currency
    ? formatPrice(account.availableCredits, currency, false, false)
    : undefined
  return (
    <S.StyledBox>
      <Flex data-testid="menu-logged-in-content">
        <S.Content>
          <CreditIcon />
        </S.Content>
        <S.Text>
          {t('general.credits.balance', { v1: formattedCredits })}
        </S.Text>
      </Flex>
    </S.StyledBox>
  )
}
